export type WeekStartsOn = 0 | 1 | 2 | 3 | 4 | 5 | 6;

const FIRST_DAY_TO_WEEK_STARTS_ON: Record<number, WeekStartsOn> = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 0 };

const hasWeekInfo = (l: Partial<Intl.Locale>): l is Intl.Locale & { weekInfo: { firstDay: number } } => 'weekInfo' in l;

const hasGetWeekInfo = (l: Intl.Locale): l is Intl.Locale & { getWeekInfo: () => { firstDay: number } } =>
  'getWeekInfo' in l;

export const getWeekStartsOn = (localeCode: string): WeekStartsOn => {
  try {
    const l = new Intl.Locale(localeCode);
    let firstDay: number | undefined;
    if (hasWeekInfo(l)) firstDay = l.weekInfo.firstDay;
    else if (hasGetWeekInfo(l)) firstDay = l.getWeekInfo().firstDay;
    return FIRST_DAY_TO_WEEK_STARTS_ON[firstDay ?? -1] ?? 1;
  } catch {
    return 1;
  }
};

export const formatWeekDays = (days: string[]): string[] =>
  days.map((d) => {
    const s = d.replace(/\.$/, '').slice(0, 2);
    return s.length < 2 ? s.toUpperCase() : s.charAt(0).toUpperCase() + s.charAt(1).toLowerCase();
  });
